export enum RealEstateSupportKind {
  SELL_REAL_ESTATE = 'SellRealEstate',
  BUY_REAL_ESTATE = 'BuyRealEstate',
  FINANCING = 'Financing',
}
